// extracted by mini-css-extract-plugin
export default {"gridBlock":"GridBlock_gridBlock__WC9TV","gridBlockState":"GridBlock_gridBlockState__Cs4px","gridBlockStateError":"GridBlock_gridBlockStateError__D1FSL"};